import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { constants } from 'constants/constants';

const { TEST_REGISTRATION_STATUSES } = constants;

const getTestStepFieldsByStatus = (status) => {
  const exam_name = 'exam_name';
  const compliance_status_text = 'compliance_status_text';
  const scheduled_date = 'scheduled_date';
  const rescheduled_date = 'rescheduled_date';
  const score = 'score';
  const cancelled_by = 'cancelled_by';
  const testing_center = 'testing_center';
  const testing_center_city = 'testing_center_city';

  const statusRules = new Map([
    [TEST_REGISTRATION_STATUSES.INVITED, [exam_name, compliance_status_text]],

    [
      TEST_REGISTRATION_STATUSES.PRE_REGISTERED,
      [exam_name, compliance_status_text, scheduled_date, testing_center, testing_center_city],
    ],

    [
      TEST_REGISTRATION_STATUSES.SCHEDULED,
      [exam_name, compliance_status_text, scheduled_date, testing_center, testing_center_city],
    ],

    [
      TEST_REGISTRATION_STATUSES.COMPLETED,
      [exam_name, compliance_status_text, scheduled_date, rescheduled_date, score, testing_center, testing_center_city],
    ],

    [
      TEST_REGISTRATION_STATUSES.NO_SHOW,
      [exam_name, compliance_status_text, scheduled_date, rescheduled_date, testing_center, testing_center_city],
    ],

    [
      TEST_REGISTRATION_STATUSES.RESCHEDULED,
      [exam_name, compliance_status_text, scheduled_date, rescheduled_date, testing_center, testing_center_city],
    ],

    [
      TEST_REGISTRATION_STATUSES.CANCELLED,
      [
        exam_name,
        compliance_status_text,
        scheduled_date,
        rescheduled_date,
        cancelled_by,
        testing_center,
        testing_center_city,
      ],
    ],
  ]);

  return statusRules.get(status) || [];
};

@Component({
  selector: 'cm-test-details',
  templateUrl: './test-details.modal.component.html',
  styleUrls: ['./test-details.modal.component.scss'],
})
export class TestDetailsComponent implements OnInit {
  @Input() step;
  fields;

  constructor(private _modalService: NgbActiveModal) {}

  ngOnInit() {
    this.fields = getTestStepFieldsByStatus(this.step.test_instance.compliance_status_id);
  }

  closeModal() {
    this._modalService.close();
  }

  dismissModal() {
    this._modalService.dismiss();
  }

  getVisible(fields: string[], field: string): boolean {
    return fields.indexOf(field) > -1;
  }
}
